
/**
 * Returns the number of milliseconds in the given number of minutes
 * @param minutes
 * @returns milliseconds
 */
export const minutes = (minutes: number) => {
  return minutes * 60 * 1000
}

/**
 * Returns the number of milliseconds in the given number of hours
 * @param hours
 * @returns milliseconds
 */
export const hours = (hours: number) => {
  return hours * 60 * 60 * 1000
}